<script setup lang="ts">
import DedicatedTeamContent from "~/components/molecules/DedicatedTeamContent.vue";
</script>

<template>
  <DedicatedTeamContent />
</template>
